  import React from 'react';

import Icon from 'Core/Components/Icon';
import Headline from 'Core/Components/Headline';

class NotFound extends React.Component {
  render () {
    const { homeUrl, children } = this.props;
    return (
      <grid className="NotFound" style={{ flexFlow: 'column nowrap' }}>
        <Headline text="404" />
        {!children
          ? <h3 className="w500 m5">Sorry, we couldn't find that page.</h3>
          : children
        }
        <a href={homeUrl ? homeUrl : '/'}>
          <button>
            <Icon fa="angle-double-left" /> &nbsp;
            Go Home
          </button>
        </a>
      </grid>
    );
  }
};

export default NotFound;



// WEBPACK FOOTER //
// ./client/Core/Status/NotFound.jsx